import Vue from 'vue';

Vue.component('checkin', require('./components/Checkin.vue'));
Vue.component('checkedin', require('./components/Checkedin.vue'));

Vue.component(
  "mobilefoodreport",
  require("./components/FormSubmissionReportMobileFood.vue")
);



// WEBPACK FOOTER //
// ./Modules/MobileFoodVendor/Resources/assets/js/app.js